
import {
  getHistory,
  dorecover
} from '../service/index';
import { pageCount } from '../../../src/config'

export default {
    namespaced: true,
    state(){
        return {
            maxPage: false,
            currentPage: 1,
            histories: [],
            initing: true,
            noinit: false,
            loading: false
        }
    },
    mutations:{
        SAVE_HISTORIES(state,histories){
            state.currentPage === 1 ? state.initing = false : null
            state.currentPage += 1
            state.maxPage = histories.length < pageCount
            state.histories = state.noinit ? histories : state.histories.concat(histories)
            state.noinit = false
        },
        INIT(state,flag){
            state.noinit = !flag,
            state.maxPage = false
            flag ? state.histories = [] : ''
            state.initing = !!flag
            state.currentPage = 1
            state.loading = false
        },
        LOADING(state, flag) {
            state.loading = flag
        }
    },
    actions:{
        flushHistory({commit,dispatch},{flag,groupid}){
            commit('INIT',flag)
            dispatch('getHistory', groupid)
        },
        getHistory({commit,state,rootState},groupid){
            if (state.maxPage || state.loading) {
              return
            }
            commit('LOADING', true)
            let offset = (state.currentPage - 1) * pageCount
            getHistory({
              count: pageCount,
              offset,
              fileid: rootState.dialogData.fileid,
              groupid
            },({status,data}) => {
                if (status === 200) {
                  commit('SAVE_HISTORIES', data.histories)
                } else {
                  commit('SAVE_HISTORIES', [])
                  commit('TOAST', {
                    type: 'error',
                    msg: data.result
                  }, {
                    root: true
                  })
                }
                commit('LOADING', false)
            })
        },
        dorecover({commit,rootState,dispatch},{fileid,historyid,groupid,parentid}){
            let route = rootState.route
            dorecover({
                fileid,
                groupid,
                historyid,
            },({status,data}) => {
                if (status == 200) {
                    _dw.onEvent('drive_fileaction_history_recover', {
                      type: 'success'
                    })
                    commit('TOAST', {
                      type: 'success',
                      msg: 'Recoversuc'
                    }, {
                      root: true
                    })
                    dispatch('flushHistory',{groupid})
                    if (route == 'all') {
                        dispatch('flush',{
                            smodule: 'index',
                            action: 'flush',
                            paload:{
                                parentid
                            }
                        },{root: true})
                    }else if (route == 'preview'){
                        dispatch('flush', {
                          smodule: 'preview',
                          action: 'flush',
                          paload: {
                            fileid,
                            noinit: true
                          }
                        }, {
                          root: true
                        })
                        dispatch('close', {}, {
                          root: true
                        })

                    }else if(route == 'starred'){
                        // 星标展示时间为创建星标时间 不是更新时间
                        // dispatch('flush', {
                        //   smodule: 'starred',
                        //   action: 'flush',
                        //   paload: {
                        //     noinit: true
                        //   }
                        // }, {
                        //   root: true
                        // })

                        // 更新事件
                        // dispatch('flush', {
                        //   smodule: 'events',
                        //   action: 'flush',
                        //   paload: {
                        //     noinit: true
                        //   }
                        // }, {
                        //   root: true
                        // })
                    }
                }else{
                    _dw.onEvent('drive_fileaction_history_recover', {
                      type: 'success',
                      resule: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/history.js